// extracted by mini-css-extract-plugin
module.exports =  {"alert":"WcV1ubJ15kk6EPAwmrjY"};